import { resolveApiUrl } from "../../utils/url/urlResolver";
import { getCsrfValue } from "../../api/ApiHelper";

const apiUrl = resolveApiUrl("/my-account/marketingConsent");

export function sendMarketingConsent(consent: boolean) {
  return fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify(consent),
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      CSRFToken: getCsrfValue(),
      "content-type": "application/json",
    },
  });
}
